module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "content-one"
  }, [_c('content-title', {
    attrs: {
      "title": "数据导出"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content"
  }, [_c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("数据存储")]), _vm._v(" "), _c('a', {
    staticClass: "checkbox-one",
    attrs: {
      "href": "javascript:;"
    }
  }, [(_vm.down1) ? _c('img', {
    attrs: {
      "src": require("assets/checked-2.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.down1 = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.down1) ? _c('img', {
    attrs: {
      "src": require("assets/unchecked-2.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.down1 = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.login === 1) ? _c('div', {
    staticClass: "checkbox-label"
  }, [_vm._v("\n              演示数据下载 "), (_vm.down1) ? _c('a', {
    staticClass: "output-btn",
    attrs: {
      "href": _vm.down1 ? '/static/演示数据.xlsx' : '',
      "download": "演示数据"
    },
    on: {
      "click": _vm.down
    }
  }, [_vm._v("导出到Excel")]) : _vm._e()]) : _c('div', {
    staticClass: "checkbox-label"
  }, [_vm._v("\n              演示数据下载 "), (_vm.down1) ? _c('a', {
    staticClass: "output-btn",
    attrs: {
      "download": "演示数据"
    },
    on: {
      "click": _vm.goLgin
    }
  }, [_vm._v("导出到Excel")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("case存储")]), _vm._v(" "), _vm._l((_vm.outPutWays), function(outPutWayData) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.activeOutPutWayKey = outPutWayData.key
        }
      }
    }, [(outPutWayData.key === _vm.activeOutPutWayKey) ? _c('img', {
      attrs: {
        "src": require("assets/checked-2.png"),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": require("assets/unchecked-2.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n              " + _vm._s(outPutWayData.name) + "\n            ")])])
  }), _vm._v(" "), (this.activeCase.status) ? _c('a', {
    staticClass: "output-btn btm-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showEditName = true
      }
    }
  }, [_vm._v("存 储")]) : _vm._e()], 2)])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "系统提醒",
      "visible": _vm.showEditName,
      "size": "tiny",
      "before-close": _vm.close
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditName = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.caseName),
      callback: function($$v) {
        _vm.caseName = $$v
      },
      expression: "caseName"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("Case Name")])], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [(this.activeCase.status) ? _c('a', {
    staticClass: "output-btn btm-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showEditName = false;
        _vm.saveCase()
      }
    }
  }, [_vm._v("存 储")]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2732a947"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/tobacco/output_to.vue
// module id = 779
// module chunks = 1